import React from "react";
import { FEATURE_DISABLED_MESSAGE, FeatureAvailability, featureForPath } from "../featureAvailability";
import { LoadingState } from "./LoadingState";
import "./featureAvailability.css";

export const TrainingNotice = ({ featureName }: { featureName?: string }) => (
  <div className="training-notice" role="status">
    <div className="training-notice__icon" aria-hidden="true">
      <svg viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <path d="m3 11 13-6 13 6-13 6-13-6Z" />
        <path d="M8 14v8c4 4 12 4 16 0v-8M29 11v10" />
      </svg>
    </div>
    <div className="training-notice__content">
      <span className="training-notice__eyebrow">Training &amp; onboarding</span>
      <h2>{featureName ? `${featureName} is currently disabled` : "Personalized training is coming"}</h2>
      <p>{FEATURE_DISABLED_MESSAGE}</p>
    </div>
  </div>
);

export const FeatureAvailabilityError = ({ message, onRetry }: { message: string; onRetry: () => void }) => (
  <div className="card feature-availability-error" role="alert">
    <h2>Feature availability could not be loaded</h2>
    <p>{message}</p>
    <button type="button" className="secondary-btn" onClick={onRetry}>Try again</button>
  </div>
);

export const FeatureGate = ({ path, data, error, onRetry, isBellomyUser = false, children }: {
  path: string;
  data: FeatureAvailability | null;
  error: string | null;
  onRetry: () => void;
  isBellomyUser?: boolean;
  children: React.ReactNode;
}) => {
  // Audience rollout switches do not restrict Bellomy users.
  if (isBellomyUser) return <>{children}</>;
  const feature = featureForPath(path);
  if (!feature) return <>{children}</>;
  if (error) return <section className="page"><FeatureAvailabilityError message={error} onRetry={onRetry} /></section>;
  if (!data) return <LoadingState label="Checking feature availability…" layout="page" />;
  if (!data.features[feature.id]) {
    return <section className="page feature-disabled-page">
      <header className="page-header"><h1>{feature.label}</h1></header>
      <TrainingNotice featureName={feature.label} />
    </section>;
  }
  return <>{children}</>;
};
